import React, { Component } from 'react';
import { Visibility, Grid, Card } from 'semantic-ui-react';
import { Route } from 'react-router';

import ControlHome from './ControlHome';
import ControlResult from './ControlResult';
import HeaderNav from '../components/HeaderNav';
class App extends Component {
  render() {
    return (
      <div className="App">
        <Visibility onUpdate={this.handleUpdate}>
          <HeaderNav headerTop />
          <div
            style={{
              minHeight: '100vh'
            }}
            className="home-image"
          >
            <div
              style={{ minHeight: '100vh', margin: 'auto', display: 'flex' }}
              className="home-container"
            >
              <Grid
                style={{ height: '100%', margin: 'auto' }}
                container
                textAlign="center"
              >
                <Grid.Column
                  as={Card}
                  style={{
                    minHeight: '200px',
                    backgroundColor: 'rgba(255,255,255,0.7)',
                    display: 'flex',
                    alignItems: 'center',
                    margin: 'auto'
                  }}
                  verticalAlign="middle"
                >
                  <Route
                    exact
                    path={this.props.match.url}
                    component={ControlHome}
                  />
                  <Route
                    path={`${this.props.match.url}/:id`}
                    component={ControlResult}
                  />
                </Grid.Column>
              </Grid>
            </div>
          </div>
        </Visibility>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Control/Control.js